export const CHANGE_CURRENT_USER: string = 'CHANGE_CURRENT_USER'
export const SET_CLIENTS_BY_USER: string = 'SET_CLIENTS_BY_USER'
export const RESET_USER_STORE: string = 'RESET_STORE'
export const SET_VENDOR: string = 'SET_VENDOR'
export const SET_SYNDICATOR: string = 'SET_SYNDICATOR'
export const SET_ISO: string = 'SET_ISO'
export const SET_REP: string = 'SET_REP'
